import Layout from '@/components/Layout';
import { tokenSelector } from '@/redux/features/auth.slice';
import { BlockStack } from '@shopify/polaris';
import { useSelector } from 'react-redux';
import ChangelogWidget from '../Feedback/components/ChangelogWidget';
import HeadingBanner from './components/HeadingBanner';
import HelpCenter from './components/HelpCenter';
import LayoutFeatureBanner from './components/LayoutFeatureBanner';
import LayoutTopHome from './components/LayoutTopHome';
import NoticeBanner from './components/NoticeBanner';
import OverQuotaBanner from './components/OverQuotaBanner';
import Overview from './components/Overview';
import ReviewBanner from './components/ReviewBanner';
import YourAccount from './components/YourAccount';
import TrackingPageAccessCard from '@/components/TrackingPageAccessCard';

const Dashboard = () => {
  const { shop } = useSelector(tokenSelector);
  const shopName = shop.split('.')[0] || '';

  return (
    <Layout
      title={`Hello ${shopName},`}
      subtitle="Welcome to Synctrack Order Tracking 🎉"
      primaryAction={<YourAccount />}
      secondaryActions={<ChangelogWidget />}
    >
      <BlockStack gap="400">
        <NoticeBanner />
        <ReviewBanner />
        <HeadingBanner />
        <OverQuotaBanner />
        <LayoutTopHome />
        <TrackingPageAccessCard />
        <Overview />
        <HelpCenter />
        <LayoutFeatureBanner />
      </BlockStack>
    </Layout>
  );
};

export default Dashboard;
